// extracted by mini-css-extract-plugin
module.exports = {"melodyVideo":"Bj-z","landingPageVideo":"Cj-z","play":"Dj-z","iframeVideo":"Ej-z","playHidden":"Fj-z","fullwidth":"Gj-z"};